import { basicAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const mailjet = defineConnector({
  identifier: "mailjet",
  name: "Mailjet",
  tagLine: "Email delivery and marketing platform",
  logo,
  protocol: "http",
  tags: ["communication", "engineering"],
  defaultUrlPattern: () => "https://api\\.mailjet\\.com/.*",
  auth: (app) =>
    basicAuth({
      username: app.config.apiKey,
      password: app.secret.secretKey,
    }),
  steps: [
    {
      title: "Get API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Visit the [Mailjet API Key Management](https://app.mailjet.com/account/apikeys) page and copy your API key and secret key.",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "configuration", field: "apiKey" },
        },
        {
          kind: "input",
          label: "Secret key",
          required: true,
          target: { kind: "secrets", field: "secretKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.mailjet.com/v3/REST/apikey",
  },
});
